<template>
	<div class="goods">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onsync()">库存同步</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0" v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.shop_id" placeholder="店铺">
							<el-option :label="v.shop_name" :value="v.id" v-for="(v,k) in shop_list" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="">
						<el-input v-model="formfilter.goods_name" placeholder="商品名称"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.is_onsale" placeholder="状态">
							<el-option label="状态" value=""></el-option>
							<el-option label="下架" :value="0"></el-option>
							<el-option label="上架" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.outer_goods_id" placeholder="外部商品编码"></el-input>
					</el-form-item>
					
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="40" align="center" header-align="center" fixed="left"/>
					<el-table-column label="图片" fixed="left" align="center" header-align="center" width="120px">
						<template slot-scope="scope">
							<div class="img">
								<img :src="scope.row.thumb_url" v-if="scope.row.thumb_url">
							</div>
						</template>
					</el-table-column>
					
					<el-table-column prop="goods_name" label="商品名称" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="goods_id" label="商品编号" align="center" header-align="center" min-width="60px">
					</el-table-column>
					<el-table-column prop="style_number" label="款号" align="center" header-align="center" min-width="50px">
						<template slot-scope="scope">
							<div v-for="(v,k) in onsn(scope.row.style_number)" :key="k">{{v}}</div>
						</template>
					</el-table-column>
					<el-table-column label="商品状态" align="center" header-align="center" min-width="35px">
						<template slot-scope="scope">
							<div v-if="scope.row.is_onsale == 1">上架</div>
							<div v-if="scope.row.is_onsale == 0">下架</div>
						</template>
					</el-table-column>
					<el-table-column label="同步库存" align="center" header-align="center" min-width="35px">
						<template slot-scope="scope">
							<div v-if="scope.row.is_sync == 0">不同步</div>
							<div v-if="scope.row.is_sync == 1">同步</div>
						</template>
					</el-table-column>
					<el-table-column prop="sync_time_str" label="同步时间" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" fixed="right" width="110px">
						<template slot-scope="scope">
							<div class="operation_i">
								<div>
									<span @click="onsave(scope.row)">库存配置</span>
								</div>
								<div>
									<span @click="onlog(scope.row)">库存更新记录</span>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, total" :current-page.sync="page" :total="total" v-if="total > 0" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
		
		<el-dialog title="库存配置" :visible.sync="show" width="90%" :before-close="onclose" :close-on-click-modal="false">
			<pddsku v-if="show" :checkobj="checkobj" @onconfig_set="onlist()"></pddsku>
		</el-dialog>
		
		<el-dialog title="库存同步" :visible.sync="show1" width="650px" :before-close="onclose1">
			<div class="forms" v-if="show1">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px">
					<el-form-item label="店铺" prop="shop_id" class="item">
						<el-select v-model="ruleForm.shop_id" placeholder="请选择您要库存同步的店铺">
							<el-option :label="v.shop_name" :value="v.id" v-for="(v,k) in shop_list" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose1">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		name: 'pddgoods',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 100,
				total: 0,
				filtershow: true,
				show: false,
				show1: false,
				formfilter: {
					shop_id: "",
					goods_name: "",
					is_onsale: 1,
					outer_goods_id: ""
				},
				checkid: "",
				shop_list: [],
				shop_id: "",
				alldata: [],
				checkobj: {},
				ruleForm: {
					shop_id: "",
					goods_id: "",
				},
				rules: {
					shop_id: [{
						required: true,
						message: '请选择您要库存同步的店铺',
						trigger: 'change'
					}],
				}
			}
		},
		
		mounted() {
			this.onshop();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					shop_id: this.checkid,
					goods_name: "",
					is_onsale: 1,
					outer_goods_id: ""
				};
				this.page = 1;
				this.onlist();
			},
			
			handleCurrentChange() {
				this.onlist();
			},
			
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				// obj.limit = this.pageSize;
					
				this.$axios.post('api/user/pdd_good_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.total_count;
						this.list = res.data.data.goods_list;
						this.shop_id = obj.shop_id;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onshop() {
				var obj = {
					shop_name: "",
					state: 1,
					page: 1,
					limit: 99999
				};
								
				this.$axios.post('api/user/pdd_shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.shop_list = res.data.data.list;
						if(this.shop_list.length > 0) {
							this.formfilter.shop_id = this.shop_list[0].id;
							this.checkid = this.shop_list[0].id;
							this.onlist();
						}
						
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onsave(val) {
				this.checkobj = {
					shop_id: this.shop_id,
					goods_id: val.goods_id
				};
				this.show = true;
			},
			
			onlog(val) {	
				// this.$router.push({
				// 	path: '/buyer/pdd/skulog',
				// 	query: {
				// 		shop_id: this.shop_id,
				// 		goods_id: val.goods_id
				// 	}
				// })
				
				const url = this.$router.resolve({
					path: '/buyer/pdd/skulog',
					query: {
						shop_id: this.shop_id,
						goods_id: val.goods_id
					}
				});
				window.open(url.href, "_blank");
			},
			
			onclose() {
				this.show = false;
				this.checkobj = {};
			},
			
			onsn(str) {
				if(str) {
					var arr = str.split("|");
					return arr;
				}else {
					return [];
				}
			},
			
			handleSelectionChange(val) {
				this.alldata = val;
			},
			
			onsync() {
				var arr = JSON.parse(JSON.stringify(this.alldata));
				if(arr.length > 0) {
					this.ruleForm.goods_id = this.onids(arr);
					this.show1 = true;
				} else {
					this.$message.warning('必须选择一条数据');
				}
			},
			
			onclose1() {
				this.show1 = false;
				this.ruleForm = {
					shop_id: "",
					goods_id: "",
				}
			},
			
			onids(arrs) {
				var arr = [];
				arrs.forEach((v, k) => {
					arr.push(v.goods_id);
				})
			
				return arr.join(',')
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						this.$axios.post('/api/user/pdd_sync_sku', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose1();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.goods {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 104px);
	}
	
	.img {
		width: 100px;
		img {
			width: 100%;
		}
	}
	
	.operation_i span {
		margin: 0 !important;
	}
	
	/deep/ .item .el-select {
		width: 300px;
	}
</style>


// WEBPACK FOOTER //
// src/components/pdd/goods.vue